import { capitalize } from 'lodash';

/**
 * Plain-text equivalent of the on-screen StatusPill label
 * (`split(separator).map(capitalize).join(combiner)`), so CSV exports read the
 * same as the rendered pill. Mirror the separator/combiner the pill uses per table.
 */
export const formatStatusLabel = (
  status?: string | null,
  separator = '_',
  combiner = '-'
): string =>
  status
    ? status
        .split(separator)
        .map(text => capitalize(text))
        .join(combiner)
    : '-';
